import React, { Component } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';

import { InputField, TextAreaField } from 'Common/SemanticWrapper';
import { InputMode, PURCHASE_ORDER_INFO_FORM_NAME } from 'Common/FormEnum';
import { ControlInfoEnum } from 'Common/FieldEnum';
import { TitledCard } from 'Components';
import { FieldOfficerSignature } from './FieldOfficerSignature';
import { Main } from 'Containers';

import 'PageStyles/controlinfo/index.less';

class PurchaseOrderInfoForm extends Component {
  static propTypes = {
    mainProps: PropTypes.object.isRequired,
  };

  render() {
    const { mainProps, hide } = this.props;

    return (
        <div className={classNames({ hide: hide })}>
          <Main {...mainProps}>
            <TitledCard title="Purchase Order Information">
              <Form>
                <Grid>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <Field
                          name={ControlInfoEnum.NextPONumber}
                          component={InputField}
                          maxLength={10}
                          label="Next Purchase Order Number"
                          type="text"
                          mode={InputMode.Integer}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <div className="field input--type-text">
                        <label>APPROVER SIGNATURE</label>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <Field
                          name={ControlInfoEnum.Signature_FinanceOfficer}
                          component={FieldOfficerSignature}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                          name={ControlInfoEnum.POStatement}
                          component={TextAreaField}
                          maxLength={250}
                          label="Statement"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            </TitledCard>
          </Main>
        </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

PurchaseOrderInfoForm = connect(mapStateToProps)(PurchaseOrderInfoForm);

export default reduxForm({
  form: PURCHASE_ORDER_INFO_FORM_NAME,
  destroyOnUnmount: false,
})(PurchaseOrderInfoForm);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/PurchaseOrderInfoForm.js